import Icon from '../components/Icon.vue'

Icon.register({
  minus: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M416 208c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-384c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h384z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/minus.js
// module id = 1571
// module chunks = 0